// extracted by mini-css-extract-plugin
export default {"wrapper":"ClanStars_wrapper_c1ee8","tabs":"ClanStars_tabs_ad048","blurred":"ClanStars_blurred_e2dfd"};